import { render, staticRenderFns } from "./ApprovalFlow.vue?vue&type=template&id=784d0ea6&"
import script from "./ApprovalFlow.vue?vue&type=script&lang=js&"
export * from "./ApprovalFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports